import React from 'react'

import VersionRow from './Row'
import IncentiveBox from 'components/Utils/IncentiveBox'

const MAX_FREE_HISTORY_VERSION = 3

const VersionList = ({
  history,
  activeVersionNum,
  setActiveVersionNum,
  isLimited,
}) => {
  const shouldDisplayUpgradeBox = isLimited
  return (
    <div>
      <div className="history-navigator">
        {history
          .slice(0, isLimited ? MAX_FREE_HISTORY_VERSION : undefined)
          .map(version => (
            <VersionRow
              key={version.get('id')}
              isActive={activeVersionNum === version.get('to')}
              version={version}
              history={history}
              setActiveVersionNum={setActiveVersionNum}
            />
          ))}
      </div>
      {shouldDisplayUpgradeBox && (
        <div className="padding-normal">
          <IncentiveBox
            incentiveId="DisplayNotesHistory"
            className="margin-top-normal"
            extraItems={history.size - MAX_FREE_HISTORY_VERSION}
          />
        </div>
      )}
    </div>
  )
}

export default VersionList
